/**
 * A services to pollyfill animation functions
 * @module services/animate
 */

/**
 * Request an animation frame
 * @param {Function} callback A callback function to run after acquiring an animation frame
 * @param {Number} [delay=0] The delay for the request
 * @param {Window} _window The window object
 * @returns {NodeJS.Timeout} An function reference which can be canceled using cancelAnimationFrame
 */
export function requestAnimationFrame (callback, delay = 0, _window = window) {
  if (!process.env.BROWSER) {
    return callback
  }
  const { requestAnimationFrame: _requestAnimationFrame } = _window
  return setTimeout(() => {
    if (!process.env.BROWSER || !_requestAnimationFrame) {
      return callback()
    }
    return _requestAnimationFrame(callback)
  }, delay)
}

/**
 * Cancel an animation frame query
 * @param {NodeJS.Timeout} reference The reference to an animation frame request
 */
export function cancelAnimationFrame (reference) {
  if (reference) {
    clearTimeout(reference)
  }
}
